





















/* Created- 16 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import { ContentStreamIssueTailoringBatchDTO } from "../../Generated/ParticaAPI";
import { DateUtils } from "../../BusinessServices/dateutils";
import { eParticaAction, ParticaEvent } from "../../Models/ParticaEvent";
@Component(
	{
		name: "StreamTailoringBatches"
	})
export default class StreamTailoringBatches extends Vue {
	@Prop() private data: ContentStreamIssueTailoringBatchDTO[];
	private search: string = "";
	private headers: any = [
		{ text: "Name", value: "name" },
		{ text: "Status", value: "status" },
		{ text: "Created (YYYY-MM-DD)", value: "created" },
	];
	private getFormat(date: Date) {
		return DateUtils.FormatDate(date, "YYYY-MM-DD");
	}
	private clicked(item: ContentStreamIssueTailoringBatchDTO, e: any) {
		this.$emit("partica-event", { action: eParticaAction.CONTENT_STREAM_SHOW_BATCH, item, sourceEvent: e } as ParticaEvent);
	}
}
